import { PromoCodeType } from './PromoCodeType';
import { ByType } from './ByType';
import Assets from './Assets';
import Localization from './Localization';
import PiggyReward from './PiggyReward';

export default class PromoCode {
	_id: string;
	active: boolean;
	amount: number;
	cities?: string[];
	code: string;
	countries?: string[];
	customerGroup?: string;
	from?: string;
	mov?: number;
	states?: string[];
	to?: string;
	type: PromoCodeType;
	value?: any;
	venues: string[];
	name: string;
	availability?: ByType<boolean>;

	image: Assets;
	boundToUser: boolean;
	description: Localization;
	isMyPromo: boolean;
	generalPromoCode: boolean;
	giftCards?: string[];
	usedGiftCards?: string[];
	isMultipleApplicable: boolean;
	label?: string | PromoCode;
	availableForCustomerToUse?: boolean;
	piggyReward: PiggyReward;
	redeemableAtCheckoutOnly?: boolean;
	piggyRewardUuid: string;
}
